import { defineComponent as m, computed as n, createElementBlock as s, openBlock as a, createElementVNode as d, createCommentVNode as u, toDisplayString as c } from "vue";
import { getExtension as p } from "../Document.helpers.js";
const x = { class: "flex max-w-full shrink overflow-hidden" }, f = { class: "text-static-default-hi body-1-bold shrink truncate text-right" }, h = {
  key: 0,
  class: "text-static-default-low grow text-left"
}, v = /* @__PURE__ */ m({
  __name: "DocumentName",
  props: {
    name: {}
  },
  setup(r) {
    const e = r, l = n(() => {
      const t = e.name.lastIndexOf(".");
      return t === -1 ? e.name : e.name.slice(0, t);
    }), o = n(() => p(e.name));
    return (t, i) => (a(), s("div", x, [
      d("span", f, c(l.value), 1),
      o.value ? (a(), s("span", h, "." + c(o.value), 1)) : u("", !0)
    ]));
  }
});
export {
  v as default
};
